import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  IconType,
  InternalIcon,
} from '@src/app/shared/enums/internal-icon.enum';
import { Entity } from '@src/app/shared/models/entity.model';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-copy-entity',
  templateUrl: './copy-entity.component.html',
})
export class CopyEntityComponent {
  copied: boolean = false;
  @Input() isLoadingEntity = false;
  @Input() entity!: Entity;
  @Input() hideCopyNumber = false;

  @Output() triggerCopy = new EventEmitter();
  @Output() triggerShowCopiesData = new EventEmitter();
  IconType = IconType;
  InternalIcon = InternalIcon;

  toggleCopy(): void {
    this.copied = true;
    this.triggerCopy.emit();
    timer(3000)
      .pipe(take(1))
      .subscribe(() => {
        this.copied = false;
      });
  }

  showCopiesData(): void {
    this.triggerShowCopiesData.emit();
  }
}
